/*
 * Copyright (c) 2026 Tezi Communications LLP, India
 * All rights reserved. Private and Confidential.
 */
import { registerSW } from 'virtual:pwa-register';

export function initPWA() {
  // Register service worker for PWA functionality
  console.info('[PWA] Post-mount initialization starting...');
  
  registerSW({
    onRegistered(r: ServiceWorkerRegistration | undefined) {
      if (r) {
        console.info('[PWA] SW registered: ', r);
        window.setLoadingStatus?.('Service worker online.', 30);
        
        // Monitor installation state
        const sw = r.installing || r.waiting || r.active;
        if (sw) {
          sw.addEventListener('statechange', (e) => {
            const state = (e.target as any).state;
            if (state === 'installing') {
              window.setLoadingStatus?.('Downloading offline cache...', 40);
            }
            if (state === 'activated') {
              window.setLoadingStatus?.('Offline experience ready.', 50);
            }
          });
        }
      }
    },
    onRegisterError(error: unknown) {
      console.error('[PWA] SW registration failed: ', error);
      window.setLoadingStatus?.('Offline mode unavailable.', 30);
    },
  });

  // Listen for precaching progress from SW
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'SW_PRECACHE_PROGRESS') {
        const { progress, asset } = event.data.payload;
        if (asset) {
          window.setLoadingStatus?.(`Syncing ${asset}...`, 60 + (progress * 0.3));
        }
      }
    });
  }
}
